import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch, useSelector } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateCompanyAPI, CreateSupplierApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const branchId = userData.branchId || "";

const CreateSupplierModal = ({ Open, setOpen }) => {
  const [Name, setName] = useState("");
  const [Address, setAddress] = useState("");
  const [Contact, setContact] = useState("");
  const [Email, setEmail] = useState("");
  const [Desc, setDesc] = useState("");
  const [CNIC, setCNIC] = useState("");
  const [Loading, setLoading] = useState(false);
  // const dispatch = useDispatch();
  // const Auth = useSelector((state) => state.auth);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (Name === "") {
      WarningToast("Enter a valid name");
    } else if (Address === "") {
      WarningToast("Enter a valid address");
    } else if (Contact === "") {
      WarningToast("Enter a valid contact number");
    } else {
      try {
        const response = await CreateCompanyAPI({
          name: Name,
          contact: Contact,
          description: Desc,
          address: Address,
          branchId: branchId,
        });
        if (response.data.success) {
          setOpen(false);
          SuccessToast("Supplier added successfully");
          // dispatch(fetchSuppliers());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to add supplier");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Company
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <AuthInput
            label="Name"
            placeholder="Enter Name"
            Value={Name}
            setValue={setName}
          />
          <AuthInput
            label="Address"
            placeholder="Enter Address"
            Value={Address}
            setValue={setAddress}
          />
          <AuthInput
            label="Contact"
            placeholder="Enter Contact"
            Value={Contact}
            setValue={setContact}
          />
          <AuthInput
            label="Desc"
            placeholder="Enter Description"
            Value={Desc}
            setValue={setDesc}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Add Company"} onSubmit={onSubmit} type={1} />
              <AuthBtn title={"Cancel"} onSubmit={onSubmit} type={2} />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateSupplierModal;
